import { render, staticRenderFns } from "./videoRecorder.vue?vue&type=template&id=4771aa30&scoped=true"
import script from "./videoRecorder.vue?vue&type=script&lang=js"
export * from "./videoRecorder.vue?vue&type=script&lang=js"
import style0 from "./videoRecorder.vue?vue&type=style&index=0&id=4771aa30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771aa30",
  null
  
)

export default component.exports